import { ShowOrgSettingsResponseSchema } from './show-org-settings.schema';
export const showOrgSettingsContract = {
    method: 'GET',
    path: '/api/v2/organization/settings',
    description: "Retrieve settings for the authenticated user's organization",
    responseSchema: ShowOrgSettingsResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated'
        }
    }
};

//# sourceMappingURL=show-org-settings.contract.js.map